function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.00001 13.3332C10.2217 13.3332 12.8333 10.7215 12.8333 7.49984C12.8333 4.27818 10.2217 1.6665 7.00001 1.6665C3.77834 1.6665 1.16667 4.27818 1.16667 7.49984C1.16667 10.7215 3.77834 13.3332 7.00001 13.3332Z",
  stroke: "#65A30D",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.75 5.75L5.25 9.25",
  stroke: "#65A30D",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.25 5.75L8.75 9.25",
  stroke: "#65A30D",
  strokeWidth: 0.991667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCloseIconPortfolioActive = function SvgCloseIconPortfolioActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIconPortfolioActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CloseIconPortfolioActive.818bd552.svg";
export { ForwardRef as ReactComponent };